<template>
    <v-row>
        <v-card width="100%" color="#455A64" dark>
            <v-row>
                <v-col cols="12" lg="2" md="2" sm="2" style="border-right: 1px solid white;">
                    <v-card-title
                        :style="titleStyle"
                    >
                        Missed
                    </v-card-title>
                </v-col>
                <v-col
                    v-for="(missed,i) in numbers"
                    :key="missed.no"
                    :class="numbers.length - i !== 0 ? 'vl' : ''"
                >
                    <v-card-title
                        class="justify-center"
                        :style="numberStyle1"
                    >{{ missed.no }}
                    </v-card-title>
                    <v-card-text
                        class="text-center"
                        :style="numberStyle"
                    >{{ missed.counter }}
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card>
    </v-row>
</template>

<script>
export default {
    data: () => {
        return {
            missedNumber: [],
        }
    },
    props: ['outlet'],
    computed: {
        numbers() {
            return this.missedNumber;
        },
        titleStyle() {
            return {
                fontWeight: 'bold',
                justifyContent: 'center',
                fontSize: '25px',
                wordBreak: 'normal',
            }
        },
        numberStyle1() {
            return {
                fontWeight: 'bold',
                fontSize: '30px',
                justifyContent: 'center',
                paddingBottom: '0px',
                paddingTop: '0px'
            }
        },
        numberStyle() {
            return {
                fontWeight: 'bold',
                fontSize: '25px',
                justifyContent: 'center',

            }
        }
    },
    created() {
        Echo.channel('tvcall-channel')
            .listen('.QueueNumberReceived', (e) => {
                if (e.outlet_id === this.outlet.id && e.type === "missed") {
                    if (!this.missedNumber.some(el => el.no === e.queue_number)) {
                      if (this.missedNumber.length === 5) {
                        this.missedNumber.splice(0, 1, {no: e.queue_number, counter: e.counter_no});
                      } else {
                        this.missedNumber.push({no: e.queue_number, counter: e.counter_no})
                      }
                    }
                }
            });
    }
}
</script>
<style>
.vl {
    border-right: 1px solid white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MissedNumber.vue